export class SnowflakeIntegrationConfig {
    'warehouse';
    'accountName';
    'oauth2ClientId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "warehouse",
            "baseName": "warehouse",
            "type": "string",
            "format": ""
        },
        {
            "name": "accountName",
            "baseName": "accountName",
            "type": "string",
            "format": ""
        },
        {
            "name": "oauth2ClientId",
            "baseName": "oauth2ClientId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SnowflakeIntegrationConfig.attributeTypeMap;
    }
    constructor() {
    }
}
